import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, logoTitle, mobileLogo, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100%"
          bg="#F0C2C2"
          boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25)"
          pv="5px"
          h="60px"
        >
          <CFImage
            w="167px"
            src={mobileLogo}
            alt="Osaka Sushi Courtenay Logo"
            top="10px"
          />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          w="100%"
          bg="#F0C2C2"
          boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25);"
          zIndex={98}
          h="65px"
        >
          <CFImage
            ml="6%"
            mt="7px"
            src={logo}
            maxWidth="400px"
            alt="Osaka Sushi Courtenay Logo"
            zIndex={98}
          />
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
